import { render, staticRenderFns } from "./doc6.vue?vue&type=template&id=76291580"
import script from "./doc6.vue?vue&type=script&lang=js"
export * from "./doc6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports